"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
function isDefined(variable) {
    return typeof variable !== 'undefined';
}
exports.isDefined = isDefined;
//# sourceMappingURL=isDefined.js.map